import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export default {
  async update(commentId: Id, data: ApiRequests['api.v1.comments.update']) {
    return await api(route('api.v1.comments.update', commentId), 'patch', {
      data,
    });
  },

  async destroy(commentId: Id) {
    return await api(route('api.v1.comments.destroy', commentId), 'delete');
  },
};
